/* eslint-disable */
import { createState, useState } from '@hookstate/core';
// import { initial } from "lodash";
// import { initial } from "lodash";
import ApiHelper from '../utility/ApiHelper';
import APIURLConstants from '../config/config';
import Helper from '../utility/helper';
import { setTheme } from '../hookState/ThemeState';

const initialState = {
    isLoggedIn: false,
    appDetails: {},
    blobStorage: {},
    eventTab: 0,
    noAccess: false,
};

const authState = createState(initialState);

export const getDetails = async () => {
    const userInfo = Helper.getStorage('userInfo');
    const agentConn = Helper.getStorage('agentConnections')

    ApiHelper.get(APIURLConstants.GET_APP_DETAILS)
        .then((res) => {
            if (res && res.data) {
                // if(!userInfo){
                if (!agentConn && agentConn == null) {
                    Helper.setStorage('userInfo', res.data.letsgoUser);
                }
                // } 
                // Helper.setStorage('blobStorage', res.data.blobStorage);
                //Helper.setStorage('chk', 'jr');
                const eventInfo = Helper.getStorage('eventInfo');
                if (eventInfo) {
                    setTheme(eventInfo);
                }
                authState.set({
                    ...initialState,
                    // update me with data from network call
                    appDetails: res.data,
                    blobStorage: res.data.blobStorage,
                    isLoggedIn: true,
                    noAccess: false,
                });
            }
        })
        .catch(error => {
            console.log('check err : ', error);
            if (error != undefined && error.response.status == 403) {
                authState.set({
                    ...initialState,
                    noAccess: true,
                });
            }
            else if (error != undefined && error.response.status == 401) {
                if (Helper.getStorage('chk') == 'aad') {
                    const date = new Date();
                    const ts = date.getTime();

                    //... Append a time stamp so that the browsers don't cache the url.
                    const publicUrl = new URL(
                        process.env.PUBLIC_URL,
                        window.location.origin
                    );
                    const url = `${publicUrl}?ts=${ts}`;
                    // window.location.href = url;
                    // setTimeout(() => {
                    //     //... Redirect to home to get silent token again
                    //     window.location.href = url;
                    // }, 1000);
                }
            }

            // if (Helper.getStorage('chk') == 'aad') {

            //     
            // }
        });
}
export const login = async () => {
    debugger; // eslint-disable-line no-debugger
    ApiHelper.get(APIURLConstants.GET_APPLICATION_DETAILS)
        .then((res) => {
            Helper.setStorage('userInfo', res.data.letsgoUser);
            Helper.setStorage('chk', 'aad');
            const eventInfo = Helper.getStorage('eventInfo');
            if (eventInfo) {
                setTheme(eventInfo);
            }
            authState.set({
                ...initialState,
                // update me with data from network call
                appDetails: res.data,
                isLoggedIn: true,
            });
        })
        .catch(error => {
            console.log('check err : ', error);
        });
};

export const logout = () => {
    // set authState to initial state
    authState.set(initialState);
};

// react hook for consuming
export const useAuthState = () => {
    return useState(authState);
};
